const prefix = "/~yangz6/Nucleome_Browser/NB_session/example/"
const entries = [
    {genome:"human (hg38)",session:prefix + "entry_page_human" + ".json", image:""},
    {genome:"mouse (mm10)",session:prefix + "entry_page_mouse" + ".json", image:""},
]
export default entries
